import { Box, styled } from "@mui/material";
import { HeroSection, FeaturesSection, InfoSection, BannerSection } from "../components";

const PageContainer = styled(Box)(({ theme }) => ({
  paddingTop: "125px",
  paddingBottom: "100px",
  display: "flex",
  flexDirection: "column",
  gap: "100px",
  [theme.breakpoints.down("md")]: {
    padding: "37px 12px 80px 12px",

    gap: "80px",
    },
  }));

export const IndividualsPage = () => {
  return (
    <PageContainer>
      <HeroSection />
      <FeaturesSection />
      <InfoSection />
      {/* <BusinessSection /> */}
      <BannerSection />
    </PageContainer>
  );
};
